module.exports = __webpack_public_path__ + "assets/img/bg.5ece6d97.png";